var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { type } from "@colyseus/schema";
import { Player } from "./Player.js";
/**
 * Arena-specific player state. Inherits all of Player's positional fields
 * and adds the running coin-collection score for this match.
 */
export class ArenaPlayer extends Player {
    constructor() {
        super(...arguments);
        this.score = 0;
    }
}
__decorate([
    type("number")
], ArenaPlayer.prototype, "score", void 0);
//# sourceMappingURL=ArenaPlayer.js.map